module.exports = __webpack_public_path__ + "img/apidays-onsite-2.374d29ba.jpg";